import { useEffect, useState } from "react";
import { useCommonComponentContext } from "@maysoft/common-component-react";

import Helpers from "../../../commons/helpers";
import TopicService from "../../../services/message/Topic.service";
import { ITopic } from "../../../commons/interfaces";

export type ITopicError = { [k in keyof ITopic]?: string };

const useData = ({ id }: { id: string }) => {
    const { onError = () => {}, onShowLoading = () => {}, onHideLoading = () => {} } = useCommonComponentContext();

    const [data, setData] = useState<ITopic>({} as ITopic);
    const [error, setError] = useState<ITopicError>({} as ITopicError);

    useEffect(() => {
        getDetail(id);
    }, []);

    const getDetail = async (id: string) => {
        try {
            if (Helpers.isNullOrEmpty(id)) return;
            onShowLoading();
            const result = await TopicService.getDetail(id);
            setData(result);
        } catch (error) {
            const e = Helpers.renderExceptionError(error);
            onError(e);
        } finally {
            onHideLoading();
        }
    };

    const onChangeValue = (value: string, key: keyof ITopic) => {
        if (!Helpers.isNullOrEmpty(error[key])) setError((prev) => ({ ...prev, [key]: "" }));
        setData((prev) => ({ ...prev, [key]: value }));
    };

    return { data, error, setError, onChangeValue, getDetail };
};

export default useData;
